<template>
  <b-icon
    :icon="icon"
    :pack="pack"
    :size="size"
    :style="{ color: _CssColor }"
  />
</template>

<script>
/**
 * Icono de capa teñido con el color DXF de la capa (entero 0xRRGGBB).
 * Convierte el entero a hex "#rrggbb". Si `color` es null/undefined usa gris.
 *
 * Uso:
 *   <layer-color-icon :color="layer.color" />
 *   <layer-color-icon :color="layer.color" icon="layer-group" size="is-small" />
 */
export default {
  name: 'LayerColorIcon',

  props: {
    color: { type: [Number, String], default: null },
    icon:  { type: String, default: 'layer-group' },
    pack:  { type: String, default: 'fas' },
    size:  { type: String, default: null },
  },

  computed: {
    _CssColor() {
      const v = this.color;
      if (v === null || v === undefined || v === '') return '#9ca3af';
      // Si ya es un string hex ("#abc" o "abc123") lo devolvemos tal cual.
      if (typeof v === 'string') {
        return v.startsWith('#') ? v : '#' + v;
      }
      // Entero DXF → hex padded a 6 dígitos.
      let s = v.toString(16);
      while (s.length < 6) s = '0' + s;
      return '#' + s;
    },
  },
};
</script>
